import axios from 'axios';

const API_URL = 'https://seethakalyanavaibhogame.com/skvadmin/api';
// const API_URL = 'http://localhost:8000/api';

const objectToArray = (data) => {
    if (!data || typeof data !== 'object') return [];
    
    try {
        return Object.entries(data).map(([id, name]) => {
            // Ensure id and name are properly formatted
            const cleanId = String(id).trim();
            const cleanName = String(name).trim();
            
            // Skip invalid entries
            if (!cleanId || !cleanName) return null;
            
            return { 
                id: cleanId, 
                name: cleanName 
            };
        }).filter(Boolean); // Remove null entries
    } catch (error) {
        console.error('Error converting object to array:', error);
        return [];
    }
};

const getCountryList = async () => {
    const res = await axios.get(`${API_URL}/getCountryList`);
    return objectToArray(res.data.data || {});
};

const getStatesList = async (countryId) => {
    const res = await axios.get(`${API_URL}/getStatesList/${countryId}`);
    return objectToArray(res.data.data || {});
};

const getCitiesList = async (stateId) => {
    const res = await axios.get(`${API_URL}/getCitiesList/${stateId}`);
    return objectToArray(res.data.data || {});
};

const getQualificationList = async () => {
    const res = await axios.get(`${API_URL}/getQualificationList`);
    return objectToArray(res.data.data || {});
};

const getRaasiList = async () => {
    const res = await axios.get(`${API_URL}/getRaasiList`);
    return objectToArray(res.data.data || {});
};

const getNakshatraList = async () => {
    try {
        const res = await axios.get(`${API_URL}/getNakshatraList`);
        const data = res.data.data || {};
        const result = objectToArray(data);
        
        // Additional validation for nakshatra data
        if (result.length > 0) {
            console.log('Nakshatra data loaded:', result.length, 'entries');
        }
        
        return result;
    } catch (error) {
        console.error('Error fetching nakshatra list:', error);
        return [];
    }
};

const getPadamList = async (starId) => {
    try {
        const res = await axios.get(`${API_URL}/getPadamList/${starId}`);
        const data = res.data.data || {};
        const result = objectToArray(data);
        
        // Additional validation for padam data
        if (result.length > 0) {
            console.log('Padam data loaded:', result.length, 'entries');
        }
        
        return result;
    } catch (error) {
        console.error('Error fetching padam list:', error);
        return [];
    }
};

const getCasteList = async () => {
    try {
        const res = await axios.get(`${API_URL}/getCasteList`);
        const data = res.data.data || {};
        const result = objectToArray(data);
        
        // Additional validation for caste data
        if (result.length > 0) {
            console.log('Caste data loaded:', result.length, 'entries');
            // Log any potential duplicate names for debugging
            const names = result.map(item => item.name);
            const uniqueNames = new Set(names);
            if (names.length !== uniqueNames.size) {
                console.warn('Duplicate caste names detected:', names.filter((name, index) => names.indexOf(name) !== index));
            }
        }
        
        return result;
    } catch (error) {
        console.error('Error fetching caste list:', error);
        return [];
    }
};

const getCasteCategoryList = async () => {
    const res = await axios.get(`${API_URL}/getCasteCategoryList`);
    return objectToArray(res.data.data || {});
};

const getPreferredCallingTimes = async () => {
    const res = await axios.get(`${API_URL}/getPreferredCallingTimes`);
    return objectToArray(res.data.data || {});
};

const getComplexionList = async () => {
    const res = await axios.get(`${API_URL}/getComplexionList`);
    // Convert object format {id: name} to array format [{id, name}]
    const complexionData = res.data.data || {};
    return Object.entries(complexionData).map(([id, name]) => ({ id, name }));
};

const searchUsers = async (searchParams) => {
    try {
        const response = await axios.get(`${API_URL}/searchUsers`, {
            params: searchParams
        });
        return response.data.data || [];
    } catch (error) {
        console.error('Error searching users:', error);
        return [];
    }
};

const getProfilePurchasesDetails = async () => {
    try {
        const response = await axios.get(`${API_URL}/getProfilePurchasesDetails`);
        return response.data.data || [];
    } catch (error) {
        console.error('Error fetching purchased profiles:', error);
        throw new Error('Failed to fetch purchased profiles');
    }
};

const getRecommendedUsers = async () => {
    try {
        const response = await axios.get(`${API_URL}/recommendUsers`);
        return response.data.users || [];
    } catch (error) {
        console.error('Error fetching recommended users:', error);
        return [];
    }
};

const getUserDetails = async (userId) => {
    try {
        const response = await axios.get(`${API_URL}/getUserDetails/${userId}`);
        return response.data.data || {};
    } catch (error) {
        console.error('Error fetching user details:', error);
        return {};
    }
};

const likeUser = async (likedId, likerId, action) => {
    try {
        const response = await axios.post(`${API_URL}/like`, {
            liked_id: likedId,
            liker_id: likerId,
            action: action // 'liked' or 'unliked'
        });
        return response.data;
    } catch (error) {
        console.error('Error liking user:', error);
        throw error;
    }
};

const interestUser = async (likedId, likerId, action) => {
    try {
        const response = await axios.post(`${API_URL}/interest`, {
            receiver_id: likedId,
            sender_id: likerId,
            action: action // 'interested' or 'not_interested'
        });
        return response.data;
    } catch (error) {
        console.error('Error showing interest:', error);
        throw error;
    }
};
const createPayment = async (payload) => {
    const res = await axios.post(`${API_URL}/createPayment`, payload);
    return res.data;
};
const getInterestSent = async (userId) => {
    const res = await axios.get(`${API_URL}/getInterestSent`);
    return res.data;
};
const getInterestReceived = async (userId) => {
    const res = await axios.get(`${API_URL}/getInterestReceived`);
    return res.data;
};
const acceptInterest = async (interestId, userId, senderId) => {
    const res = await axios.post(`${API_URL}/acceptInterest`, {
        interest_id: interestId,
        user_id: userId,
        sender_id: senderId
    });
    return res.data;
};
//rejectInterest
const rejectInterest = async (interestId, userId, senderId) => {
    const res = await axios.post(`${API_URL}/rejectInterest`, {
        interest_id: interestId,
        user_id: userId,
        sender_id: senderId
    });
    return res.data;
};

const getPlans = async () => {
    try {
        const response = await axios.get(`${API_URL}/GetPlans`);
        return response.data.plans || [];
    } catch (error) {
        console.error('Error fetching plans:', error);
        return [];
    }
};

const masterService = {
    getCountryList,
    getStatesList,
    getCitiesList,
    getQualificationList,
    getRaasiList,
    getNakshatraList,
    getPadamList,
    getCasteList,
    getCasteCategoryList,
    getPreferredCallingTimes,
    getComplexionList,
    searchUsers,
    getProfilePurchasesDetails,
    getRecommendedUsers,
    getUserDetails,
    likeUser,
    interestUser,
    createPayment,
    getInterestSent,
    getInterestReceived,
    acceptInterest,
    rejectInterest,
    getPlans,
};

export default masterService;
